import {
  IAccountCredit,
  IAppointment,
  IAppointmentRequest,
  IBrand,
  ICalendarEvent,
  IInvoice,
  ILabJob,
  IOrganisation,
  IPatient,
  IPaymentPlan,
  IPractice,
  IRecurringTask,
  IStaffer,
  ITask,
  ITransaction,
  ITreatmentCategory,
} from '@principle-theorem/principle-core/interfaces';
import { Timestamp, WithRef } from '@principle-theorem/shared';

export interface IOrganisationPubSubData {
  organisation: WithRef<IOrganisation>;
}

export interface IBrandPubSubData extends IOrganisationPubSubData {
  timestamp: Timestamp;
  brand: WithRef<IBrand>;
}

export interface IPracticePubSubData extends IBrandPubSubData {
  practice: WithRef<IPractice>;
}

export interface IBasePatientTopicData extends IBrandPubSubData {
  patient: WithRef<IPatient>;
}

export interface IBaseAccountCreditTopicData extends IBrandPubSubData {
  patient: WithRef<IPatient>;
  accountCredit: WithRef<IAccountCredit>;
  invoice?: WithRef<IInvoice>;
  practice?: WithRef<IPractice>;
  transactions: WithRef<ITransaction>[];
  treatmentCategory?: WithRef<ITreatmentCategory>;
}

export interface IBaseAppointmentTopicData extends IPracticePubSubData {
  patient: WithRef<IPatient>;
  appointment: WithRef<IAppointment>;
  treatmentCategory?: WithRef<ITreatmentCategory>;
  appointmentRequest?: WithRef<IAppointmentRequest>;
}

export interface IBaseLabJobTopicData extends IPracticePubSubData {
  labJob: WithRef<ILabJob>;
}

export interface IBasePaymentPlanTopicData extends IBasePatientTopicData {
  paymentPlan: WithRef<IPaymentPlan>;
}

export interface IBaseTaskTopicData extends IPracticePubSubData {
  task: WithRef<ITask>;
}

export interface IBaseRecurringTaskTopicData extends IPracticePubSubData {
  recurringTask: WithRef<IRecurringTask>;
}

export interface IBaseCalendarEventTopicData {
  brand: WithRef<IBrand>;
  staffer: WithRef<IStaffer>;
  calendarEvent: WithRef<ICalendarEvent>;
}
